module.exports = __webpack_public_path__ + "media/my_images/search/job_opening-570479e5fe3a9e1ef4dab2bd58c656c6.png";